import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import NewThaiDatePicker from "../../components/Common/NewThaiDatePicker";

import { ConvertDate } from "../Function/ConvertDate";
import axios from "axios";
import { GetCookieData, GetCookieToken } from "../Cookie/GetCookie";
import { fullMonthNames, shortMonthNames } from "../../common/data/monthName";
import ApproveHistory from "./ApproveHistory";
import { FetchAxiosGet } from "../../api/axios";
import { checkFinalApprove } from "../Function/CheckFinalApprove";
import { useStateManager } from "react-select";
import { leaveConfigFlow } from "./LeaveStepHelper";
import FadeIn from "react-fade-in";
import Lottie from "react-lottie";
import * as loadingBar from "../TESTPage/loadingBar.json";
// import ApproveHistory from "./ApproveHistory";

const ModalApproveData = ({
  userInfo,
  modalEditApprove = false,
  leaveDataEdit = null,
  setLeaveDataEdit,
  leaveDataEditApprove,
  CloseDataApprove,
  getUserApprove,
  checkLeaveTypeIdAndPosition,
  user_position,
  checkPosition,
  showApproveButton,
  nextt
}) => {
  const baseURL = process.env.REACT_APP_API_CORS;
  // const userApproveForPSED = Number(process.env.REACT_APP_USER_APPROVE_FOR_PSED);
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const leaderInfo = userInfo?.leader;
  const user_id = user?.user_id;

  const [configForm, setConfigForm] = useState([]);
  // const [vacationRemain, setVacationRemain] = useState([]);
  const [leavePerson, setLeavePerson] = useState([]);
  const [leavePersonDate, setLeavePersonDate] = useState([]);
  const [leaveVacation, setLeaveVacation] = useState([]);
  const [leaveVacationDate, setLeaveVacationDate] = useState([]);
  const [holiday, setHoliday] = useState([]);
  const [allDayCancel, setAllDayCancel] = useState([]);
  const [selectDayCancel, setSelectDayCancel] = useState([]);
  const [selectDayCancel2, setSelectDayCancel2] = useState([]);

  const convertDate = (date) => {
    const DateSplit = {
      toDate: () => {
        const part1 = date?.split("T")[0];
        const part2 = part1?.split("-")[2];
        return part2;
      },
      toMonth: () => {
        const part1 = date?.split("T")[0];
        const part2 = part1?.split("-")[1];
        return shortMonthNames[part2 - 1];
      },
      toYear: () => {
        const part1 = date?.split("T")[0];
        const part2 = part1?.split("-")[0];
        return parseInt(part2) + 543;
      },
    };

    return DateSplit;
  };
  const finalApproveLeave = checkLeaveTypeIdAndPosition(
    user_id === userInfo?.psac_user_approve?.approve_user_id ? 7 : user_position,
    leaveDataEditApprove?.leave_approve_id,
    leaveDataEditApprove?.leave_data_id,
    leaveDataEdit?.leave_status,
    leaveDataEditApprove,
    leaveDataEdit,
    true,
    true,
    false,)

  const getLeavePerson = async () => {
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 5,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_id][0]": user_id,
        "filter[form_type][0]": 1,
        "filter[leave_type_id][0]": 2,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setLeavePerson(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };

  const getLeaveVacation = async () => {
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 5,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_id][0]": user_id,
        "filter[form_type][0]": 2,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setLeaveVacation(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };

  const getConfigAll = async () => {
    try {
      const res = await axios.get(baseURL + "/api/leave/config/all", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setConfigForm(res?.data?.form_leave[leaveDataEdit?.form_type - 1]);
    } catch (err) {
      console.error(err);
    }
  };

  const getHoliday = async (year) => {
    try {
      const res = await axios.get(baseURL + `/api/masterdata/holiday/${year}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setHoliday(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };

  const getDateCancelDayBeforeRequestCancelById = async (id = "", allCancel = []) => {
    try {
      const url = baseURL + "/api/leave/cancel/list/datatable";
      const params = new URLSearchParams({
        page: 1,
        size: 10000,
        "order[0]": "date_cancel",
        "order[1]": "ASC",
        "filter[leave_data_id][0]": id,
        "filter[cancel_date_status][0]": 1
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setSelectDayCancel(res?.data?.result);
      res?.data?.result &&
        res?.data?.result?.map((item) => {
          if (
            allCancel?.length > 0 && allCancel?.find(
              (a) =>
                new Date(a?.date_cancel)?.toLocaleDateString() ===
                new Date(item?.date_cancel)?.toLocaleDateString()
            )
          ) {
            setAllDayCancel((prev) =>
              prev.filter(
                (a) =>
                  new Date(a?.date_cancel)?.toLocaleDateString() !==
                  new Date(item?.date_cancel)?.toLocaleDateString()
              )
            );
          }
        });
    } catch (err) {
      console.error(err);
    }
  };
  const getDateCancelDayAfterRequestCancelById = async (id = "", allCancel = []) => {
    try {
      const url = baseURL + "/api/leave/cancel/list/datatable";
      const params = new URLSearchParams({
        page: 1,
        size: 10000,
        "order[0]": "date_cancel",
        "order[1]": "ASC",
        "filter[leave_data_id][0]": id,
        "filter[cancel_date_status][0]": 2
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setSelectDayCancel2(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };

  const getAllDayCancel = (
    startCancel = new Date(),
    endCancel = new Date()
  ) => {
    const isWeekend = (date) => {
      const day = new Date(date)?.getDay();
      return day === 6 || day === 0; // 6 คือวันเสาร์, 0 คือวันอาทิตย์
    };

    const isThaiPublic = (date) => {
      const localDate = new Date(date);
      localDate.setHours(0, 0, 0, 0);
      return holiday.some((item) => {
        const startDate = new Date(item?.date_start_holiday)?.setHours(
          0,
          0,
          0,
          0
        );
        const endDate = new Date(item?.date_end_holiday)?.setHours(0, 0, 0, 0);
        return localDate >= startDate && localDate <= endDate;
      });
    };

    setAllDayCancel([]);
    let ref = [];

    for (
      let i = new Date(new Date(startCancel).setHours(0, 0, 0, 0));
      i <= new Date(new Date(endCancel).setHours(0, 0, 0, 0));
      i.setDate(i.getDate() + 1)
    ) {
      let currentDate = new Date(i);
      let newOBJ = {
        date_cancel: currentDate,
      };
      if (!isWeekend(i) && !isThaiPublic(i)) {
        ref.push(newOBJ);

        setAllDayCancel((prev) => [...prev, newOBJ]);
      }
    }
    return ref;
  };

  const [nextApproveUser, setNextApproveUser] = useState()

  const getSeq = async (leave_user_id, leave_type_id) => {
    await FetchAxiosGet(`/api/approvalSequence/${leave_user_id}`, token).then(async response => {
      let next = null
      let seq = response?.result
      let lastApprovePosition = leaveDataEditApprove?.thisLeaveConfigFlow?.find(x => x?.last_approve === 1)?.users_position_id

      let thisApproveUserIndex = seq.findIndex(x => Number(x?.user_id) === user_id)
      let lastApproveUserIndex = seq.findIndex(x => (x?.assign === 1 && x?.position_main.length > 0) ? x?.position_main[0]?.position_id === lastApprovePosition : (x?.position_id === lastApprovePosition))

      // console.log(seq, lastApprovePosition, thisApproveUserIndex, lastApproveUserIndex, lastApprovePosition);

      if (thisApproveUserIndex !== -1 && lastApproveUserIndex !== -1) {
        if (thisApproveUserIndex === lastApproveUserIndex) {
          next = seq[thisApproveUserIndex]
        } else if (thisApproveUserIndex > lastApproveUserIndex) {
          next = seq[thisApproveUserIndex - 1]
        }
      }
      setNextApproveUser(next)
    })
  }

  useEffect(() => {
    if (leaveDataEdit) {
      getConfigAll()
    }
    if (leaveDataEdit?.form_type === 2) {
      getHoliday(new Date()?.getFullYear());
      // getVacationRemain();
      let allCancel = []
      allCancel = getAllDayCancel(
        new Date(leaveDataEdit?.leave_from_date),
        new Date(leaveDataEdit?.leave_to_date)
      );
      getDateCancelDayBeforeRequestCancelById(leaveDataEdit?.leave_data_id, allCancel)
      getDateCancelDayAfterRequestCancelById(leaveDataEdit?.leave_data_id, allCancel)
    } else if (leaveDataEdit?.form_type === 3) {
      getLeavePerson();
      getLeaveVacation();
    }
    // }, [leaveDataEdit]);
  }, [leaveDataEdit]);

  const [vacationDay, setVacationDay] = useState()
  const [vacationDayRemean, setVacationDayRemean] = useState()

  const getLeaveChartByUserId = async (budgetYear, userId) => {
    const res = (budgetYear && userId) ? await axios.get(baseURL + `/api/leave/chart/1/${budgetYear}/${userId}`, { headers: { Authorization: `Bearer ${token}` } }) : {};
    let insteadRes = res?.data?.result
    let vacation = insteadRes?.years_worked >= 10 ? insteadRes?.vacation_over10 : insteadRes?.vacation_under10
    let vacationTotal = insteadRes?.years_worked >= 10
      ? (insteadRes?.vacation_limit_day?.max + (insteadRes?.vacation_over10?.vacation_day_prev || 0)) > 30
        ? 30 : insteadRes?.vacation_limit_day?.max + (insteadRes?.vacation_over10?.vacation_day_prev || 0)
      : (insteadRes?.vacation_limit_day?.max + (insteadRes?.vacation_under10?.vacation_day_prev || 0)) > 20
        ? 20 : insteadRes?.vacation_limit_day?.max + (insteadRes?.vacation_under10?.vacation_day_prev || 0)
    let vacationRemean = vacationTotal - (vacation?.use ?? 0)
    setVacationDay(vacationTotal)
    setVacationDayRemean(vacationRemean)
  }

  useEffect(() => {
    (leaveDataEdit?.user_id && leaveDataEdit?.leave_type_id) && getSeq(leaveDataEdit?.user_id, leaveDataEdit?.leave_type_id)
    getLeaveChartByUserId(leaveDataEdit?.budget_year, leaveDataEdit?.user_id)
  }, [leaveDataEdit?.user_id, leaveDataEdit?.leave_type_id])

  const checkCancelTimeType = (cancelDayObject) => {
    return (cancelDayObject?.leave_from_timetype === "1" && cancelDayObject?.leave_to_timetype === "1") ? "1"
      : (cancelDayObject?.leave_from_timetype === "2" && cancelDayObject?.leave_to_timetype === "2") ? "2"
        : "0";
  }

  const showRestLeaveAndAbsenceLeave = async (id) => {
    let res_string = "";
    const params = new URLSearchParams({
      page: 1,
      size: 5,
      "order[0]": "created_date",
      "order[1]": "DESC",
      "filter[leave_data_id][0]": id,
    });

    try {
      const response = await FetchAxiosGet('/api/leave/datatable', token, params);
      res_string =
        convertDate(response?.result[0]?.leave_from_date).toDate() + " " +
        convertDate(response?.result[0]?.leave_from_date).toMonth() + " " +
        convertDate(response?.result[0]?.leave_from_date).toYear() +
        " - " +
        convertDate(response?.result[0]?.leave_to_date).toDate() +
        " " +
        convertDate(response?.result[0]?.leave_to_date).toMonth() +
        " " +
        convertDate(response?.result[0]?.leave_to_date).toYear();
      return res_string;
    } catch (err) {
      console.error(err);
      return ""; // กรณี error ให้ return ค่าว่าง
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (leaveDataEdit?.abroad_ref) {
        const result = await showRestLeaveAndAbsenceLeave(leaveDataEdit.abroad_ref);
        setLeaveVacationDate(result); // อัปเดตค่าใน state
      }

      if (leaveDataEdit?.abroad_ref_2) {
        const result = await showRestLeaveAndAbsenceLeave(leaveDataEdit.abroad_ref_2);
        setLeavePersonDate(result)
      }
    };

    fetchData();
  }, [leaveDataEdit?.abroad_ref, leaveDataEdit?.abroad_ref_2]);

  const [flowLoading, setFlowLoading] = useState()
  const [leaveConfigFlowData, setLeaveConfigFlowData] = useState({ thisFlow: [], lastUserApprove: {}, sendToFinal: false })

  useEffect(() => {
    const getLeaveConfigFlow = async () => {
      setFlowLoading(true)
      let flow = await leaveConfigFlow(token, baseURL, userInfo, leaveDataEdit?.leave_type_id)
      setLeaveConfigFlowData(flow)
      setFlowLoading(false)
    }
    leaveDataEdit?.leave_type_id && getLeaveConfigFlow()
  }, [leaveDataEdit?.leave_type_id])

  return (
    <Modal
      centered
      size="xl"
      isOpen={modalEditApprove}
      toggle={async () => {
        CloseDataApprove();
      }}
    >
      <ModalHeader toggle={CloseDataApprove}>รายละเอียดการลา</ModalHeader>
      <ModalBody>
        {flowLoading ? (
          <FadeIn>
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: loadingBar.default,
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              width={180}
              height={180}
            />
          </FadeIn>
        ) : (<>
          <Form
            onSubmit={async (e) => {
              e.preventDefault();
              // formValidate?.handleSubmit();

              return false;
            }}
          >
            <FormGroup row className="mt-3">
              <Label className="text-end" xs={3} xxl={2}>
                เลขที่ใบลา :{" "}
              </Label>
              <Label xs={9} xxl={10}>{leaveDataEdit?.leave_data_id}</Label>
              <Label className="text-end" xs={3} xxl={2} lg={3} md={3}>
                เขียนที่ :
              </Label>
              <Label className="" xs={9} xxl={4}>
                {leaveDataEdit?.write_place}
              </Label>
              <Label className="text-end" xs={3} xxl={2} lg={3} md={3}>
                วันที่เขียน :
              </Label>
              <Label className="" xs={9} xxl={4}>
                {ConvertDate(leaveDataEdit?.write_date)?.toThaiDateDMY()}
              </Label>
              <Label className="text-end" xs={3} xxl={2} lg={3} md={3}>
                {leaveDataEdit?.form_type === 7 && (
                  <span className="me-1 text-danger">*</span>
                )}
                เรื่อง :
              </Label>
              <Label className="" xs={9} xxl={10}>
                {leaveDataEdit?.form_type === 2
                  ? "ขอลาพักผ่อน"
                  : leaveDataEdit?.form_type === 3
                    ? "ขออนุญาตไปต่างประเทศ"
                    : leaveDataEdit?.form_type === 4
                      ? "ขอลาอุปสมบท"
                      : leaveDataEdit?.form_type === 5
                        ? "ขอลาไปประกอบพิธีฮัจญ์"
                        : leaveDataEdit?.form_type === 6
                          ? "ขอลาเพื่อเข้ารับการเตรียมพล"
                          : leaveDataEdit?.form_type === 8
                            ? "ขอลาติดตามคู่สมรส"
                            : leaveDataEdit?.form_type === 9
                              ? "การไปปฏิบัติราชการนอกสำนักงาน ก.พ.ร."
                              : leaveDataEdit?.form_type === 10
                                ? "การลงเวลาปฏิบัติราชการ"
                                : leaveDataEdit?.leave_name}
              </Label>
              <Label className="text-end" xs={3} xxl={2} lg={3} md={3}>
                เรียน :
              </Label>
              <Label className="" xs={9} xxl={10}>
                {console.log(finalApproveLeave)}
                {finalApproveLeave?.sendToApprove ? (finalApproveLeave?.sendToApprove?.split("-")[0] ?? "") : ""}
              </Label>
              <Label className="text-end" xs={3} xxl={2} lg={3} md={3}>
              </Label>
              <Label xs={9} xxl={10}>{finalApproveLeave?.sendToApprove ? (finalApproveLeave?.sendToApprove?.split("-")[1] ?? "") : ""}</Label>
              <Label className="text-end" xs={3} xxl={2} lg={3} md={3}>
                ชื่อ :
              </Label>
              <Label className="" xs={9} xxl={10}>
                {leaveDataEdit?.created_user}
              </Label>
              {/* <Label className="text-end" xxl={2} lg={3} md={3}>
              ตำแหน่ง :
            </Label>
            <Label className="" xxl={10} lg={3} md={3}>
              {leaveDataEdit?.user_position_name}
            </Label>
            <Label className="text-end" xxl={2} lg={3} md={3}>
              สังกัด/กอง :
            </Label>
            <Label className="" xxl={10} lg={3} md={3}>
              {leaveDataEdit?.cont_to_name_1}
            </Label> */}
            </FormGroup>
            {leaveDataEdit?.form_type === 1 && (
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3} lg={3} md={3}>
                  <span className="me-1 text-danger">*</span>ขอลา
                </Label>
                <Col xxl={3} xs={9} lg={9} md={9}>
                  <Input
                    disabled
                    type="select"
                    value={leaveDataEdit?.leave_type_id}
                  >
                    {configForm?.leave_type?.map((item) => {
                      return (
                        <option
                          key={item?.leave_type_id}
                          value={item?.leave_type_id}
                        >
                          {item?.leave_name}
                        </option>
                      );
                    })}
                  </Input>
                </Col>
              </FormGroup>
            )}
            {/* {leaveDataEdit?.form_type === 2 && (
            <>
              <FormGroup row className="d-flex align-items-center">
                <Label className="text-end" xxl={3}>
                  วันลาพักผ่อนสะสม
                </Label>
                <Col xxl={3}>
                  <Input
                    disabled
                    type="text"
                    value={
                      vacationRemain?.years_worked < 10
                        ? vacationRemain?.vacation_under10?.max
                        : vacationRemain?.vacation_over10?.max
                    }
                  />
                </Col>
                <Label xxl={6}>
                  มีสิทธิลาพักผ่อนปีนี้อีก{" "}
                  <strong className="text-primary font-size-16">
                    {vacationRemain?.years_worked < 10
                      ? vacationRemain?.vacation_limit_day?.max +
                        vacationRemain?.vacation_under10?.use -
                        vacationRemain?.vacation_limit_day?.use +
                        vacationRemain?.vacation_under10?.max
                      : vacationRemain?.vacation_limit_day?.max +
                        vacationRemain?.vacation_over10?.max -
                        vacationRemain?.vacation_limit_day?.use +
                        vacationRemain?.vacation_over10?.use}
                  </strong>{" "}
                  วันทำการ (นับรวมการลาที่ยังไม่อนุมัติ)
                </Label>
              </FormGroup>
              <FormGroup row>
                <Label className="text-end" xxl={3}>
                  รวมเป็น
                </Label>
                <Col xl={3}>
                  <Input
                    disabled
                    value={
                      vacationRemain?.years_worked < 10
                        ? vacationRemain?.vacation_limit_day?.max +
                          vacationRemain?.vacation_under10?.max
                        : vacationRemain?.vacation_limit_day?.max +
                          vacationRemain?.vacation_over10?.max
                    }
                    type="text"
                  />
                </Col>
              </FormGroup>
            </>
          )} */}
            {leaveDataEdit?.form_type === 3 && (
              <>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    มีความประสงค์จะลา
                  </Label>
                  <Col xs={9} xl={4}>
                    <Input disabled type="text" value="ไปต่างประเทศ" />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    <span className="me-1 text-danger">*</span>เพื่อไป
                  </Label>
                  <Col xs={9} xl={4}>
                    <Input
                      disabled
                      name="abroad_for"
                      type="text"
                      value={leaveDataEdit?.abroad_for}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    <span className="me-1 text-danger">*</span>ณ ประเทศ
                  </Label>
                  <Col xs={9} xl={4}>
                    <Input
                      disabled
                      name="abroad_country"
                      value={leaveDataEdit?.abroad_country}
                      type="text"
                    />
                  </Col>
                </FormGroup>
              </>
            )}
            {leaveDataEdit?.form_type === 4 && (
              <>
                <FormGroup row>
                  <Col xs={2} md={2} xl={3}></Col>
                  <Col xs={9} md={9} xl={8}>
                    <Row>
                      <Col xs={2} md={2} xl={1}>
                        <Input
                          disabled
                          name="ordinate_ever"
                          type="radio"
                          className="font-size-18 border border-secondary mt-auto"
                          defaultChecked={
                            leaveDataEdit?.ordinate_ever === "0" && true
                          }
                        />
                      </Col>
                      <Col xs={10} md={10} xxl={4}>
                        <Label check>ยังไม่เคยอุปสมบท</Label>
                      </Col>
                      <Col xs={2} md={2} xl={1}>
                        <Input
                          disabled
                          name="ordinate_ever"
                          type="radio"
                          className="font-size-18 border border-secondary mt-auto"
                          defaultChecked={
                            leaveDataEdit?.ordinate_ever === "1" && true
                          }
                        />
                      </Col>
                      <Col xs={10} md={10} xxl={4}>
                        <Label check>เคยอุปสมบท</Label>
                      </Col>
                    </Row>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xs={4} xxl={3}>
                    <span className="me-1 text-danger">*</span>จะอุปสมบท ณ วัด
                  </Label>
                  <Col xs={8} xl={4}>
                    <Input
                      disabled
                      name="ordinate_temple"
                      type="text"
                      value={leaveDataEdit?.ordinate_temple}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    <span className="me-1 text-danger">*</span>ตั้งอยู่ ณ
                  </Label>
                  <Col xs={9} xl={4}>
                    <Input
                      disabled
                      name="ordinate_temple_place"
                      value={leaveDataEdit?.ordinate_temple_place}
                      type="text"
                    />
                  </Col>
                  <Label className="text-end" xs={3} xl={2}>
                    <span className="me-1 text-danger">*</span>วันที่อุปสมบท
                  </Label>
                  <Col xs={9} xl={3}>
                    {/* <Flatpickr
                    disabled
                    name="ordinate_date"
                    className="form-control d-block"
                    placeholder="วัน/เดือน/ปี"
                    options={{
                      dateFormat: "d-m-Y",
                      ariaDateFormat: "F j, Y",
                      locale: "th",
                    }}
                    value={leaveDataEdit?.ordinate_date}
                  /> */}
                    <NewThaiDatePicker disabled={true} name={"ordinate_date"} value={leaveDataEdit?.ordinate_date} setValue returnType={"DateTime"} placeholderText="วัน/เดือน/ปี" />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    <span className="me-1 text-danger">*</span>จำพรรษา ณ วัด
                  </Label>
                  <Col xs={9} xl={4}>
                    <Input
                      disabled
                      name="ordinate_live_temple"
                      value={leaveDataEdit?.ordinate_live_temple}
                      type="text"
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    <span className="me-1 text-danger">*</span>ตั้งอยู่ ณ
                  </Label>
                  <Col xs={9} xl={4}>
                    <Input
                      disabled
                      name="ordinate_live_place"
                      value={leaveDataEdit?.ordinate_live_place}
                      type="text"
                    />
                  </Col>
                </FormGroup>
              </>
            )}
            {leaveDataEdit?.form_type === 5 && (
              <FormGroup row>
                <Col xs={3} xl={3}></Col>
                <Col xs={9} xl={8}>
                  <Row>
                    <Col xs={2} xl={1}>
                      <Input
                        disabled
                        required
                        name="hujj_ever"
                        defaultChecked={leaveDataEdit?.hujj_ever === "0" && true}
                        className="font-size-18 border border-secondary mt-auto"
                        type="radio"
                      />
                    </Col>
                    <Col xs={10} xl={5}>
                      <Label check>ยังไม่เคยไปประกอบพิธีฮัจญ์ </Label>
                    </Col>
                    <Col xs={2} xl={1}>
                      <Input
                        disabled
                        name="hujj_ever"
                        type="radio"
                        defaultChecked={leaveDataEdit?.hujj_ever === "1" && true}
                        className="font-size-18 border border-secondary mt-auto"
                      />
                    </Col>
                    <Col xs={10} xl={5}>
                      <Label check>เคยไปประกอบพิธีฮัจญ์</Label>
                    </Col>
                  </Row>
                </Col>
              </FormGroup>
            )}
            {leaveDataEdit?.form_type === 6 && (
              <>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    <span className="me-1 text-danger">*</span>
                    ได้รับหมายเรียกของ
                  </Label>
                  <Col xs={9} xl={4}>
                    <Input
                      disabled
                      name="conscription_from"
                      value={leaveDataEdit?.conscription_from}
                      type="text"
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    <span className="me-1 text-danger">*</span>ที่
                  </Label>
                  <Col xs={9} xl={4}>
                    <Input
                      disabled
                      name="conscription_place"
                      type="text"
                      value={leaveDataEdit?.conscription_place}
                    />
                  </Col>
                  <Label className="text-end" xs={3} xxl={2}>
                    <span className="me-1 text-danger">*</span>ลงวันที่
                  </Label>
                  <Col xs={9} xl={3}>
                    {/* <Flatpickr
                    required
                    disabled
                    name="conscription_date"
                    className="form-control d-block"
                    placeholder="วัน/เดือน/ปี"
                    options={{
                      // altInput: true,
                      dateFormat: "d-m-Y",
                      ariaDateFormat: "F j, Y",
                      locale: "th",
                    }}
                    value={leaveDataEdit?.conscription_date}
                  /> */}
                    <NewThaiDatePicker disabled={true} name={"conscription_date"} value={leaveDataEdit?.conscription_date} placeholderText="วัน/เดือน/ปี" />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    <span className="me-1 text-danger">*</span>ให้เข้ารับการ
                  </Label>
                  <Col xs={9} xl={4}>
                    <Input
                      disabled
                      name="conscription_for"
                      type="text"
                      value={leaveDataEdit?.conscription_for}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    <span className="me-1 text-danger">*</span>ณ ที่
                  </Label>
                  <Col xs={9} xl={4}>
                    <Input
                      disabled
                      name="conscription_to_place"
                      value={leaveDataEdit?.conscription_to_place}
                      type="text"
                    />
                  </Col>
                </FormGroup>
              </>
            )}
            {leaveDataEdit?.form_type === 7 && (
              <>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    <span className="me-1 text-danger">*</span>ณ ประเทศ
                  </Label>
                  <Col xs={9} xl={4}>
                    <Input
                      disabled
                      name="abroad_country"
                      type="text"
                      value={leaveDataEdit?.abroad_country}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    ด้วยทุน(ถ้ามี)
                  </Label>
                  <Col xs={9} xl={4}>
                    <Input
                      disabled
                      type="text"
                      value={leaveDataEdit?.training_fund_from}
                    />
                  </Col>
                </FormGroup>
              </>
            )}
            {leaveDataEdit?.form_type === 8 && (
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  <span className="me-1 text-danger">*</span>มีความประสงค์จะลา
                </Label>
                <Col xs={9} xl={4}>
                  <Input type="text" disabled value="ติดตามคู่สมรส" />
                </Col>
              </FormGroup>
            )}
            {leaveDataEdit?.form_type === 9 && (
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  <span className="me-1 text-danger">*</span>สถานที่
                </Label>
                <Col xs={9} xl={8}>
                  <Input
                    name="outside_place"
                    type="text"
                    value={leaveDataEdit?.outside_place}
                  />
                </Col>
              </FormGroup>
            )}
            {leaveDataEdit?.form_type === 11 && (
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  มีความประสงค์จะลา
                </Label>
                <Col xs={9} xxl={8}>
                  <Input
                    disabled
                    type="select"
                    value={leaveDataEdit?.leave_type_id}
                  >
                    {configForm?.leave_type?.map((item, idx) => {
                      return (
                        <option
                          key={item?.leave_type_id}
                          value={item?.leave_type_id}
                        >
                          {item?.leave_name}
                        </option>
                      );
                    })}
                  </Input>
                </Col>
              </FormGroup>
            )}
            {leaveDataEdit?.form_type === 1 || leaveDataEdit?.form_type === 11 ? (
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3} lg={3} md={3}>
                  <span className="me-1 text-danger">*</span>เนื่องจาก
                </Label>
                <Col xs={9} xxl={8} lg={9} md={9}>
                  <Input
                    disabled
                    className="form-control"
                    type="textarea"
                    name="leave_reason"
                    value={leaveDataEdit?.leave_reason}
                    style={{ height: "75px" }}
                  />
                </Col>
              </FormGroup>
            ) : null}

            <FormGroup row>
              <Label
                className="text-end mt-2"
                xxl={leaveDataEdit?.form_type === 10 ? 4 : 3}
                xs={3}
                lg={3}
                md={3}
              >
                <span className="me-1 text-danger">*</span>
                {leaveDataEdit?.form_type === 10
                  ? "ไม่สามารถลงปฏิบัติราชการเมื่อวันที่"
                  : "ตั้งแต่วันที่"}
              </Label>
              <Col xs={9} xxl={3} lg={9} md={9} className="mt-2">
                {/* <Flatpickr
                disabled
                className="form-control d-block"
                placeholder="วัน/เดือน/ปี"
                options={{
                  dateFormat: "d-m-Y",
                  ariaDateFormat: "F j, Y",
                  locale: "th",
                }}
                value={leaveDataEdit?.leave_from_date}
              /> */}
                <NewThaiDatePicker disabled={true} name={"leave_from_date"} value={leaveDataEdit?.leave_from_date} returnType={"DateTime"} placeholderText="วัน/เดือน/ปี" />
              </Col>
              {leaveDataEdit?.form_type !== 4 &&
                leaveDataEdit?.form_type !== 8 ? (
                <>
                  <Label
                    className="mt-2"
                    style={{ textAlign: "end" }}
                    xs={3}
                    xxl={2}
                    lg={3}
                    md={3}
                  >
                    ช่วงเวลา
                  </Label>
                  <Col xs={9} xl={3} lg={9} md={9} className="mt-2">
                    <Input
                      disabled
                      type="select"
                      value={leaveDataEdit?.leave_from_timetype}
                    >
                      <option value="1">9.30</option>
                      <option value="2">13.00</option>
                    </Input>
                  </Col>
                </>
              ) : null}
            </FormGroup>
            <FormGroup row>
              <Label
                className="text-end mt-2"
                xxl={leaveDataEdit?.form_type === 10 ? 4 : 3}
                xs={3}
                lg={3}
                md={3}
              >
                <span className="me-1 text-danger">*</span>ถึงวันที่
              </Label>
              <Col xs={9} xl={3} lg={9} md={9} className="mt-2">
                {/* <Flatpickr
                disabled
                className="form-control d-block"
                placeholder="วัน/เดือน/ปี"
                options={{
                  // altInput: true,
                  dateFormat: "d-m-Y",
                  ariaDateFormat: "F j, Y",
                  locale: "th",
                }}
                value={leaveDataEdit?.leave_to_date}
              /> */}
                <NewThaiDatePicker disabled={true} name={"leave_to_date"} value={leaveDataEdit?.leave_to_date} returnType={"DateTime"} placeholderText="วัน/เดือน/ปี" />
              </Col>
              {leaveDataEdit?.form_type !== 4 &&
                leaveDataEdit?.form_type !== 8 ? (
                <>
                  <Label
                    style={{ textAlign: "end" }}
                    xs={3}
                    xl={2}
                    lg={3}
                    md={3}
                    className="mt-2"
                  >
                    ช่วงเวลา
                  </Label>
                  <Col xs={9} xl={3} lg={9} md={9} className="mt-2">
                    <Input
                      disabled
                      type="select"
                      value={leaveDataEdit?.leave_to_timetype}
                    >
                      <option value="1">12.00</option>
                      <option value="2">17.30</option>
                    </Input>
                  </Col>
                </>
              ) : null}
            </FormGroup>
            {leaveDataEdit?.form_type === 2 && (
              <>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    ยกเว้นวันที่
                  </Label>
                  <Col xs={9} xxl={3}>
                    <Input
                      disabled
                      type="select"
                      value=""
                    >
                      <option value="">เลือกวันที่ต้องการยกเลิก</option>
                    </Input>
                  </Col>
                </FormGroup>
                {selectDayCancel?.length === 0 ? null : (
                  <FormGroup row className="d-flex align-items-center">
                    {selectDayCancel?.map((item, idx) => {
                      const DateItem = new Date(item?.date_cancel);
                      let showDate = ConvertDate(
                        item?.date_cancel
                      )?.toThaiDateDMY();
                      return (
                        <React.Fragment key={idx}>
                          <Label className="text-end" xs={3} xxl={4}>
                            <i
                              style={{
                                cursor: "default",
                              }}
                              className="fa-solid fa-circle-xmark font-size-18 me-2 text-danger"
                            ></i>
                            {showDate}
                          </Label>
                          <Label style={{ textAlign: "end" }} xs={3} xl={2} lg={3}>
                            ช่วงเวลา
                          </Label>
                          <Col xs={9} xl={3} lg={9} md={9} className="mt-2">
                            <Input disabled value={checkCancelTimeType(item)} type="select">
                              <option value="0">เต็มวัน</option>
                              <option value="1">ครึ่งวันเช้า</option>
                              <option value="2">ครึ่งวันบ่าย</option>
                            </Input>
                          </Col>
                        </React.Fragment>
                      );
                    })}
                  </FormGroup>
                )}
                {(
                  <FormGroup row>
                    <Label className="text-end mt-2" xxl={3} xs={3} lg={3} md={3}></Label>
                    <Col xs={9} xl={3} lg={9} md={9} className="mt-2"></Col>
                    {leaveDataEdit?.form_type === 2 ? (
                      <>
                        <Label
                          style={{ textAlign: "end" }}
                          xs={3}
                          xl={2}
                          lg={3}
                          md={3}
                          className="mt-2"
                        >
                        </Label>
                        <Col xs={9} xl={3} lg={9} md={9} className="mt-2">
                          {`จำนวนวันลาพักผ่อนทั้งหมด ${vacationDay} วัน`}
                        </Col>
                      </>
                    ) : null}
                  </FormGroup>
                )}
                {(
                  <FormGroup row>
                    <Label className="text-end mt-2" xxl={3} xs={3} lg={3} md={3}></Label>
                    <Col xs={9} xl={3} lg={9} md={9} className="mt-2"></Col>
                    {leaveDataEdit?.form_type === 2 ? (
                      <>
                        <Label
                          style={{ textAlign: "end" }}
                          xs={3}
                          xl={2}
                          lg={3}
                          md={3}
                          className="mt-2"
                        >
                        </Label>
                        <Col xs={9} xl={3} lg={9} md={9} className="mt-2">
                          {leaveDataEdit?.leave_status === "5" ? (`คงเหลือ ${(vacationDayRemean)} วัน`) : leaveDataEdit?.leave_status === "7" ? (`รวมอนุมัติครังนี้เหลือ ${(vacationDayRemean + (leaveDataEdit?.leave_days - leaveDataEdit?.change_days))} วัน`) : (`รวมอนุมัติครังนี้เหลือ ${(vacationDayRemean - leaveDataEdit?.leave_days)} วัน`)}
                        </Col>
                      </>
                    ) : null}
                  </FormGroup>
                )}
                {
                  selectDayCancel2?.length === 0 ? null :
                    (<FormGroup row>
                      <Label className="text-end" xxl={4}>
                        วันที่เปลี่ยนแปลงหลังการขอยกเลิก
                      </Label>
                    </FormGroup>)}
                {
                  selectDayCancel2?.length === 0 ? null :
                    (
                      <FormGroup row className="d-flex align-items-center">
                        {selectDayCancel2?.map((item, idx) => {
                          const DateItem = new Date(item?.date_cancel);
                          let showDate = ConvertDate(
                            item?.date_cancel
                          )?.toThaiDateDMY();
                          return (
                            <React.Fragment key={idx}>
                              <Label className="text-end" xxl={4}>
                                <i
                                  style={{
                                    cursor: "default",
                                  }}
                                  className="fa-solid fa-circle-xmark font-size-18 me-2 text-danger"
                                ></i>
                                {showDate}
                              </Label>
                              <Label style={{ textAlign: "end" }} xs={3} xl={2} lg={3}>
                                ช่วงเวลา
                              </Label>
                              <Col xs={9} xl={3} lg={9} md={9} className="mt-2">
                                <Input disabled value={checkCancelTimeType(item)} type="select">
                                  <option value="0">เต็มวัน</option>
                                  <option value="1">ครึ่งวันเช้า</option>
                                  <option value="2">ครึ่งวันบ่าย</option>
                                </Input>
                              </Col>
                            </React.Fragment>
                          );
                        })}
                      </FormGroup>
                    )}
              </>
            )}
            <FormGroup row style={{ display: "flex", alignItems: "center" }}>
              <Label className="text-end" xs={3} xxl={3} lg={3} md={3}>
                รวม
              </Label>
              <Col xs={9} xl={3} lg={9} md={9}>
                <Input disabled type="text" value={`${leaveDataEdit?.leave_days} ${leaveDataEdit?.leave_status === "7" || leaveDataEdit?.leave_status === "B" ? `(หากมีการอนุมัติยกเลิกจะมีวันลารวม ${leaveDataEdit?.change_days} วัน)` : ""}`} />
              </Col>
            </FormGroup>
            {leaveDataEdit?.form_type !== 3 &&
              leaveDataEdit?.form_type !== 4 &&
              leaveDataEdit?.form_type !== 5 &&
              leaveDataEdit?.form_type !== 6 &&
              leaveDataEdit?.form_type !== 7 &&
              leaveDataEdit?.form_type !== 8 &&
              leaveDataEdit?.form_type !== 9 &&
              leaveDataEdit?.form_type !== 10 &&
              leaveDataEdit?.form_type !== 11 && (
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3} lg={3} md={3}>
                    <span className="me-1 text-danger">*</span>สถานที่ติดต่อ
                  </Label>
                  <Col xs={9} xxl={8} lg={9} md={9}>
                    <Input
                      disabled
                      name="contact_address"
                      className="form-control"
                      value={leaveDataEdit?.contact_address}
                      style={{ height: "75px" }}
                      type="textarea"
                    />
                  </Col>
                </FormGroup>
              )}
            {leaveDataEdit?.form_type === 3 && (
              <>
                {/* <FormGroup row style={{ display: "flex", alignItems: "center" }}>
                <Label className="text-end" xs={3} xl={3}>
                  ได้ลากิจวันที่
                </Label>
                <Label xs={4} xl={9}>กรุณากรอก ลากิจ หรือ ลาพักผ่อน ก่อน</Label>
              </FormGroup> */}
                <FormGroup row>
                  {/* <Col xs={3} xl={3}></Col> */}
                  {leaveDataEdit?.abroad_ref_2 &&
                    <>
                      <Label className="text-end" xs={3} xl={3}>
                        ได้ลากิจวันที่
                      </Label>
                      <Col xs={9} xl={3}>
                        <Input disabled type="text" value={leavePersonDate}>
                        </Input>
                      </Col>
                    </>}
                  {leaveDataEdit?.abroad_ref &&
                    <>
                      <Label className="text-end" xs={3} xl={leaveDataEdit?.abroad_ref_2 ? 2 : 3}>
                        ได้ลาพักผ่อนวันที่
                      </Label>
                      <Col xs={9} xl={3}>
                        <Input disabled type="text" value={leaveVacationDate}>
                        </Input>
                      </Col>
                    </>}
                </FormGroup>
              </>
            )}
            {leaveDataEdit?.form_type === 8 && (
              <>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    <span className="me-1 text-danger">*</span>ชื่อคู่สมรส
                  </Label>
                  <Col xs={9} xl={4}>
                    <Input
                      name="spouse_name"
                      type="text"
                      value={leaveDataEdit?.spouse_name}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    ตำแหน่งคู่สมรส
                  </Label>
                  <Col xs={9} xl={4}>
                    <Input type="text" value={leaveDataEdit?.spouse_position} />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    สังกัดคู่สมรส
                  </Label>
                  <Col xs={9} xl={4}>
                    <Input type="text" value={leaveDataEdit?.spouse_department} />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    <span className="me-1 text-danger">*</span>ปฏิบัติงาน ณ ประเทศ
                  </Label>
                  <Col xs={9} xl={4}>
                    <Input
                      name="spouse_country"
                      type="text"
                      value={leaveDataEdit?.spouse_country}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    <span className="me-1 text-danger">*</span>ตั้งแต่วันที่
                  </Label>
                  <Col xs={9} xxl={4}>
                    {/* <Flatpickr
                    className="form-control d-block"
                    placeholder="วัน/เดือน/ปี"
                    options={{
                      // altInput: true,
                      dateFormat: "d-m-Y",
                      ariaDateFormat: "F j, Y",
                      locale: "th",
                    }}
                    value={leaveDataEdit?.spouse_from_date}
                  /> */}
                    <NewThaiDatePicker disabled={true} name={"spouse_from_date"} value={leaveDataEdit?.spouse_from_date} returnType={"DateTime"} placeholderText="วัน/เดือน/ปี" />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    <span className="me-1 text-danger">*</span>ถึงวันที่
                  </Label>
                  <Col xs={9} xxl={4}>
                    {/* <Flatpickr
                    className="form-control d-block"
                    placeholder="วัน/เดือน/ปี"
                    options={{
                      // altInput: true,
                      dateFormat: "d-m-Y",
                      ariaDateFormat: "F j, Y",
                      locale: "th",
                    }}
                    value={leaveDataEdit?.spouse_to_date}
                  /> */}
                    <NewThaiDatePicker disabled={true} name={"spouse_from_date"} value={leaveDataEdit?.spouse_to_date} returnType={"DateTime"} placeholderText="วัน/เดือน/ปี" />
                  </Col>
                </FormGroup>
              </>
            )}
            {leaveDataEdit?.form_type === 10 && (
              <FormGroup row>
                <Label className="text-end" xs={3} xxl={3}>
                  <span className="me-1 text-danger">*</span>เหตุผล
                </Label>
                <Col xs={9} xl={8}>
                  <Input
                    name="practice_reason"
                    type="text"
                    value={leaveDataEdit?.practice_reason}
                  />
                </Col>
              </FormGroup>
            )}
            <FormGroup row>
              <Label className="text-end" xs={3} xxl={3} lg={3} md={3}>
                หมายเหตุ
              </Label>
              <Col xs={9} xxl={8} lg={9} md={9}>
                <Input
                  disabled
                  value={leaveDataEdit?.note || ""}
                  style={{ height: "75px" }}
                  type="textarea"
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label className="text-end" xs={3} xxl={3} lg={3} md={4}>
                แนบเอกสาร{" "}
              </Label>
              <Col xs={9} xxl={8} lg={9} md={8}>
                <Row className="d-flex align-items-center">
                  <Col>
                    <Button className="btn btn-info w-100" disabled={!(leaveDataEdit?.file_data)} onClick={() => {
                      window.open(`${baseURL}${leaveDataEdit?.file_data.split('./public')[1]}`, "_blank", "noopener,noreferrer");
                    }}>
                      {leaveDataEdit?.file_data ? (leaveDataEdit?.file_data.split('/file/')[1]) : "ไม่มีไฟล์แนบ"}
                    </Button>
                  </Col>
                </Row>
              </Col>
            </FormGroup>
            <FormGroup></FormGroup>
            {showApproveButton && (<FormGroup row style={{ display: "flex", alignItems: "center" }}>
              <Label className="text-end" xxl={3} lg={3} md={3}>
                {(finalApproveLeave.nextIsFinal !== null) ? (finalApproveLeave.nextIsFinal ? 'ส่งผู้อนุมัติ' : 'ส่งผู้อนุญาต') :
                  (finalApproveLeave.isFinal !== null) ? (finalApproveLeave.isFinal ? 'ส่งผู้อนุมัติ' : '') : ''}
              </Label>
              <Col xl={4} lg={9} md={9}>
                <Input disabled value={nextApproveUser?.user_name ?? ""} type="text" />
              </Col>
            </FormGroup>)}
            <FormGroup row style={{ display: "flex", justifyContent: "end" }}>
              <Col xs={12} md={8} lg={6} xxl={4} className="d-flex">
                {showApproveButton && (user_id === userInfo?.psac_user_approve?.approve_user_id || user_position) && finalApproveLeave.component}
              </Col>
            </FormGroup>
          </Form>

          <Row
            className="mt-3"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Col xxl={8}>
              {getUserApprove && getUserApprove && <ApproveHistory getUserApprove={getUserApprove} user={user} leaveDataEdit={leaveDataEdit} />}
            </Col>
          </Row>
        </>)}
      </ModalBody>
    </Modal>
  );
};

export default ModalApproveData;
